import React from 'react';
import KickImage from 'Reuseables/KickImage';

/** CSS import */
import Styles from './BlogHeader.module.scss';

import MenuButtonContainer from './Components/Molecules/MenuButtonContainer';
import TitleContainer from './Components/Molecules/TitleContainer';
import LinkContainer from './Components/Molecules/LinkContainer';
import SearchOverlay from './Components/Organisms/SearchOverlay';
import { joinClassnames } from 'helpers/classNames';
import MenuOverlay from './Components/Organisms/MenuOverlay';
import { useBackListener } from 'Pages/Blog/Hooks/useBackListener';
import { useKeyboardKeyListener } from 'Pages/Blog/Hooks/useKeyboardKeyListener';

const BlogHeader: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpenedMenu, setIsOpenedMenu] = React.useState(false);

  useBackListener(() => {
    setIsOpen(false);
    setIsOpenedMenu(false);
  }, isOpen || isOpenedMenu);

  useKeyboardKeyListener('Escape', () => {
    setIsOpen(false);
    setIsOpenedMenu(false);
  });

  return (
    <div
      className={joinClassnames(
        Styles['main-wrapper'],
        !isOpen && !isOpenedMenu && Styles['closed'],
      )}
    >
      <div className={Styles['wrapper']}>
        <MenuButtonContainer onOpen={() => setIsOpenedMenu(true)} />
        <TitleContainer />
        <LinkContainer onOpen={() => setIsOpen(true)} />
      </div>
      <SearchOverlay isOpened={isOpen} onClosed={() => setIsOpen(false)} />
      <MenuOverlay
        isOpened={isOpenedMenu}
        onClose={() => setIsOpenedMenu(false)}
      />
    </div>
  );
};

export default BlogHeader;
